import { useState } from 'react'
import '../styles/loopnet-status-banner.css'

export default function LoopNetStatusBanner({
  loading = false,
  error = null,
  apiStatus = null,
  usingLiveDeals = false,
  liveCount = 0,
  location = '',
  onRetry = null,
}) {
  const [dismissed, setDismissed] = useState(false)
  const httpStatus = apiStatus?.httpStatus
  const isRateLimit = httpStatus === 429 || String(error || '').includes('429')
  const isMonthlyQuota = String(error || '').toLowerCase().includes('monthly quota')

  if (loading) {
    return (
      <div className="lnsb lnsb--loading" role="status">
        <span className="lnsb__spinner" aria-hidden="true" />
        <span className="lnsb__text">
          Connecting to LoopNet API{location ? ` - ${location}` : ''}...
        </span>
      </div>
    )
  }

  if (usingLiveDeals && !error) {
    if (dismissed) return null
    return (
      <div className="lnsb lnsb--live" role="status">
        <span className="lnsb__icon" aria-hidden="true"></span>
        <span className="lnsb__text">
          <strong>LoopNet API connected - showing live data</strong>
          {liveCount ? ` (${liveCount} listings${location ? ` near ${location}` : ''})` : ''}
        </span>
        <button
          className="lnsb__dismiss"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss LoopNet status"
        >
          x
        </button>
      </div>
    )
  }

  if (error || apiStatus?.isLive === false || !apiStatus) {
    const message = isRateLimit
      ? isMonthlyQuota
        ? 'LoopNet API monthly quota exceeded (429) - showing cached or placeholder data until RapidAPI resets or the plan is upgraded'
        : 'LoopNet API rate limit hit (429) - showing cached or placeholder data. Resets in a few minutes'
      : `LoopNet API not working - showing placeholder data${error ? `: ${error}` : ''}`

    return (
      <div className={`lnsb ${isRateLimit ? 'lnsb--warning' : 'lnsb--error'}`} role="alert">
        <span className="lnsb__icon" aria-hidden="true">{isRateLimit ? '⚠️' : '❌'}</span>
        <div className="lnsb__body">
          <strong>{message}</strong>
          <p className="lnsb__placeholder-warn">
            Placeholder data is visible because live LoopNet data is not available right now.
          </p>
        </div>
        <div className="lnsb__actions">
          {onRetry && !isRateLimit && (
            <button className="lnsb__retry-btn" onClick={onRetry}>
              Retry
            </button>
          )}
        </div>
      </div>
    )
  }

  return null
}
